import { render } from "./delegation.vue?vue&type=template&id=3682167f&scoped=true"
import script from "./delegation.vue?vue&type=script&lang=ts"
export * from "./delegation.vue?vue&type=script&lang=ts"

import "./delegation.vue?vue&type=style&index=0&id=3682167f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3682167f"

export default script